import { Preloader } from 'mmfintech-portal-commons'

const CustomPreloader = () => <Preloader color='black' />

export default CustomPreloader
